import { IMAGES } from "../lib/images";

export default function Logo({ light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img src={IMAGES.logo} alt="Tus 10 Minutos" className="w-9 h-9 object-contain" />
      <div className="leading-none">
        <span className={`block font-serif text-xl tracking-tight ${light ? "text-cream" : "text-forest"}`}>
          Tus 10 Minutos
        </span>
        <span className={`block text-[9px] tracking-[0.3em] uppercase ${light ? "text-cream/70" : "text-clay"}`}>
          Yoga Facial
        </span>
      </div>
    </div>
  );
}
